/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchNotificationHistoryResponse { 
    recipientId?: string | null;
    recipientAddress?: string | null;
    externalMessageId?: string | null;
    statusId?: number;
    groupId?: number;
    channelId?: number;
    notificationId?: string;
    createdDate?: string;
    notificationBody?: string | null;
    errorText?: string | null;
    externalSystemStatus?: string | null;
}

